<template>
  <b-modal
    id="debit-note-details-modal"
    ref="modal"
    v-model="open"
    size="md"
    no-close-on-backdrop
    hide-footer
    title="CREATE DEBIT NOTE"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <section>
        <b-card
          id="debit-note-preview-card"
          no-body
          class="invoice-preview-card"
        >
          <b-card-body class="invoice">
            <b-row>
              <b-col
                cols="12"
                md="12"
              >
                <div>
                  <table class="w-100">
                    <tbody>
                      <tr>
                        <td class="pr-1 text-left">
                          Total Return Charge:
                        </td>
                        <td class="pl-2 text-right">
                          <span>{{ companyCurrency }} {{ __numberWithCommas(totalReturnCharge, true) }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="pr-1 text-left">
                          <h6 class="font-weight-bolder mb-0">
                            Debit Note Total:
                          </h6>
                        </td>
                        <td class="pl-2 text-right">
                          <span class="font-weight-bolder">{{ companyCurrency }} {{ __numberWithCommas(debitNoteTotal, true) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <b-row class="mt-1">
          <b-col cols="12">
            <b-form-group
              label="Return Charge Rate"
              label-for="return-charge-rate"
            >
              <b-form-input
                id="return-charge-rate"
                v-model="returnChargeRate"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Remark"
              label-for="debit-note-remark"
            >
              <b-form-input
                id="debit-note-remark"
                v-model="remark"
                placeholder="Enter remark"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-col
          cols="12"
          md="4"
          xl="4"
        >
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-success"
            class="mb-75"
            block
            @click="onSubmit"
          >
            Generate
          </b-button>
        </b-col>
      </section>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BCard,
  BButton,
  BModal,
  BCol,
  BCardBody,
  BRow,
  BOverlay,
  BFormGroup,
  BFormInput,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const FinanceRepository = RepositoryFactory.get('finance')

function initialState() {
  return {
    open: false,
    modalLoading: false,
    selectedWaybills: [],
    submitFunction: () => {},
    deposit: {},
    totalReturnCharge: 0,
    returnChargeRate: 0,
    debitNoteTotal: 0,
    remark: '',
    companyCurrency: '',
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCard,
    BButton,
    BModal,
    BCol,
    BCardBody,
    BRow,
    BOverlay,
    BFormGroup,
    BFormInput,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  created() {
    const businessSettings = JSON.parse(localStorage.getItem('businessSettings') || '{}')
    this.companyCurrency = businessSettings.company_currency || ''
  },
  methods: {
    async openModal(selectedInvoices, submitFunction, invoices) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.selectedInvoices = selectedInvoices
      this.submitFunction = submitFunction
      this.invoices = invoices
      const businessSettings = JSON.parse(localStorage.getItem('businessSettings') || '{}')
      this.companyCurrency = businessSettings.company_currency || ''
      await this.getDebitNoteDetails()
    },
    async getDebitNoteDetails() {
      this.modalLoading = true
      try {
        const payload = {
          invoice_ids: this.selectedInvoices,
        }
        if (this.invoices.merchant_id) {
          payload.merchant_id = this.invoices.merchant_id
        }
        if (this.invoices.merchant_business_id) {
          payload.merchant_business_id = this.invoices.merchant_business_id
        }
        const { data } = (await FinanceRepository.getDebitNoteDetailsBeforeSubmit(payload)).data
        this.totalReturnCharge = data.total_return_charge ?? data.total_return_charges ?? 0
        this.returnChargeRate = data.return_charge_rate ?? data.return_rate ?? 0
        this.debitNoteTotal = data.debit_note_total ?? data.debit_amount ?? 0
        this.remark = ''
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    async onSubmit() {
      try {
        this.modalLoading = true
        const invoicesPayload = {
          invoice_ids: this.selectedInvoices,
          merchant_id: this.invoices.merchant_id,
          merchant_business_id: this.invoices.merchant_business_id,
          return_charge: this.totalReturnCharge,
          return_rate: this.returnChargeRate,
          debit_amount: this.debitNoteTotal,
          remark: this.remark,
        }
        await this.submitFunction(invoicesPayload)
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
  },
}
</script>
